var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fts-input-group-icon",class:[
    { 'input-group-icon--active': _vm.active },
    { 'input-group-icon--disabled': _vm.disabled } ]},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }